/* new-pdp-nord-hero.js
   Purchase module for the Nord PDP hero (variant/colour selection, pricing, cart,
   gallery, video pop-up, accessories). Moved out of the section file verbatim on
   2026-08-18 to pull sections/new-pdp-nord-hero.liquid back from the 256 KB
   write-time limit; the only edits are the three section-id lookups, which now
   take the id as an argument. One init per hero instance, keyed by the id the
   section prints on its <section> and its two JSON blobs. Re-inits on
   shopify:section:load so the theme editor keeps working after a re-render. */
(function () {
  function init(sid) {
  var root = document.getElementById('npwmp-hero-' + sid);
  if (!root || root.dataset.npwmpInit === '1') return;
  root.dataset.npwmpInit = '1';

  var dataEl = document.querySelector('[data-npwmp-data="' + sid + '"]');
  var DATA = {};
  var OFFER_LOOK = root.hasAttribute('data-npwmp-offer'); // offer look (VSL page v2): button wording + list price
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function variants(key) { return (DATA.products[key] && DATA.products[key].variants) || []; }

  var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-size]'));
  var widthBtns = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-width]'));
  var fulfillRadios = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-fulfill]'));
  var initialBtn = root.querySelector('[data-npwmp-size].active') || sizeBtns[0];
  var initialWidthBtn = root.querySelector('[data-npwmp-width].active') || widthBtns[0];
  var checkedRadio = root.querySelector('[data-npwmp-fulfill]:checked');
  var state = {
    index: initialBtn ? parseInt(initialBtn.dataset.index, 10) : (DATA.defaultIndex || 0),
    widthIndex: initialWidthBtn ? parseInt(initialWidthBtn.dataset.windex, 10) : 0,
    fulfillment: checkedRadio ? checkedRadio.value : (DATA.defaultFulfillment || 'instock')
  };

  function activeWidthBtn() { return root.querySelector('[data-npwmp-width].active'); }
  function activeLengthBtn() { return root.querySelector('[data-npwmp-size].active'); }
  function currentWidthValue() { var b = activeWidthBtn(); return b ? b.getAttribute('data-wvalue') : null; }
  function currentLengthValue() { var b = activeLengthBtn(); return b ? b.getAttribute('data-lvalue') : null; }

  // Resolve the variant for the chosen width + length within a fulfillment product.
  // Falls back to length-index matching for single-option products.
  function variantFor(key) {
    var list = variants(key);
    var w = currentWidthValue(), l = currentLengthValue();
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (DATA.hasWidth) { if (v.w === w && v.l === l) return v; }
      else if (v.l === l) return v;
    }
    return list[state.index] || null;
  }
  function activeVariant() { return variantFor(state.fulfillment); }

  // Upgrade-swap: the swap product's variant at the same POSITION as the active
  // one (both products must list their sizes in the same order — the same
  // convention the pre-order / in-stock pairing already relies on).
  function swapVariantFor() {
    var list = variants(state.fulfillment);
    var v = activeVariant();
    var idx = list.indexOf(v);
    if (idx < 0) idx = state.index || 0;
    var sw = (DATA.swap && DATA.swap.variants) || [];
    return sw[idx] || null;
  }

  // Colour-matched variant of a side product (add-on shed / "buy separately" row):
  // the variant whose option values include the active colour (the width OR the
  // length value, whichever the colour picker is bound to), else the first available.
  function matchedVariant(list) {
    list = list || [];
    var w = currentWidthValue(), l = currentLengthValue();
    var hit = null;
    for (var i = 0; i < list.length && !hit; i++) {
      var o = list[i].opts || [];
      if ((w && o.indexOf(w) >= 0) || (l && o.indexOf(l) >= 0)) hit = list[i];
    }
    if (!hit) { for (var j = 0; j < list.length; j++) { if (list[j].available) { hit = list[j]; break; } } }
    return hit || list[0] || null;
  }
  function addonVariantFor() { return (DATA.swapMode === 'addon' && DATA.swap) ? matchedVariant(DATA.swap.variants) : null; }
  function altVariantFor() { return DATA.alt ? matchedVariant(DATA.alt.variants) : null; }

  // ---- standalone in-stock detection (price-based) ----
  // This template can be assigned to a product whose pre-order / in-stock mapping is
  // reversed — e.g. an in-stock-only product still linked to a pre-order counterpart.
  // When the product in the PRE-ORDER slot is priced strictly HIGHER than the one in
  // the IN-STOCK slot, this page is really a standalone in-stock product: collapse to
  // a single in-stock buy — hide the option selector and force the in-stock button +
  // shipping note, while still selling the page product. Equal prices (e.g. lean-to)
  // are deliberately ignored — only a strictly higher pre-order price triggers this.
  var PAGE_KEY = (DATA.pageRole === 'instock') ? 'instock' : 'preorder';
  var IS_SWAPPED = (function () {
    if (!(DATA.products.preorder && DATA.products.instock)) return false;
    var pv = variantFor('preorder'), iv = variantFor('instock');
    if (!pv || !iv) return false;
    return pv.price > iv.price;
  })();
  if (IS_SWAPPED) {
    state.fulfillment = PAGE_KEY;
    var swOpts = root.querySelector('[data-npwmp-fulfill-options]');
    var swLbl = root.querySelector('[data-npwmp-fulfill-label]');
    if (swOpts) swOpts.hidden = true;
    if (swLbl) swLbl.style.display = 'none';
  }

  // Roof-window count for the current length (from the product metafield), min 1.
  function windowCount() {
    var arr = DATA.windows || [];
    var n = parseInt(arr[state.index], 10);
    return (n && n > 0) ? n : 1;
  }

  // All prices on this PDP display whole dollars (no cents), per the store rule.
  function formatCents(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  }
  var formatWhole = formatCents;

  function accQty(chk) {
    return (chk.hasAttribute('data-acc-window-qty') || chk.hasAttribute('data-acc-qty-sel')) ? (parseInt(chk.getAttribute('data-acc-qty'), 10) || 1) : 1;
  }

  // Sum of the prices (cents) of every checked accessory upsell (× its quantity).
  function accessoriesTotal() {
    var sum = 0;
    root.querySelectorAll('[data-npwmp-accessory]:checked').forEach(function (chk) {
      var p = parseInt(chk.getAttribute('data-acc-price'), 10);
      if (!isNaN(p)) sum += p * accQty(chk);
    });
    return sum;
  }

  // ---- Premium bundle card ----
  // One accessory (schema bundle_slot) is the all-in-one bundle. Its crossed-out
  // "was" price is the live sum of the OTHER add-ons (window opener × the roof
  // window count). Ticking it unchecks the others (remembering what the shopper
  // had picked) and locks them as "Included", so only the bundle product enters
  // the cart; unticking restores the shopper's own selections.
  var bundleChk = root.querySelector('[data-acc-bundle]');
  function bundleOthers() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-accessory]')).filter(function (c) { return c !== bundleChk && !c.hasAttribute('data-acc-standalone'); });
  }
  function updateBundle() {
    if (!bundleChk) return;
    // Size-dependent bundle product: while the selected size has a single roof
    // window the bundle swaps to its 1-opener counterpart (schema
    // bundle_small_product). Name and tooltip stay put; only the cart variant,
    // the price pill and the struck "was" sum change with the size.
    var smallV = bundleChk.getAttribute('data-acc-small-variant');
    if (smallV) {
      if (!bundleChk.hasAttribute('data-acc-main-variant')) {
        bundleChk.setAttribute('data-acc-main-variant', bundleChk.value);
        bundleChk.setAttribute('data-acc-main-price', bundleChk.getAttribute('data-acc-price') || '0');
      }
      var isSmall = windowCount() <= 1;
      bundleChk.value = isSmall ? smallV : bundleChk.getAttribute('data-acc-main-variant');
      // Same switch for the hidden (PRE-ORDER) counterpart. No small pre-order product
      // configured = empty, so the cart falls back to the visible small variant
      // instead of the wrong-size pre-order bundle.
      if (!bundleChk.hasAttribute('data-acc-main-preorder')) bundleChk.setAttribute('data-acc-main-preorder', bundleChk.getAttribute('data-acc-preorder-variant') || '');
      bundleChk.setAttribute('data-acc-preorder-variant', isSmall ? (bundleChk.getAttribute('data-acc-small-preorder-variant') || '') : bundleChk.getAttribute('data-acc-main-preorder'));
      bundleChk.setAttribute('data-acc-price', isSmall ? (bundleChk.getAttribute('data-acc-small-price') || '0') : bundleChk.getAttribute('data-acc-main-price'));
      var bpEl = root.querySelector('[data-npwmp-bundle-price]');
      if (bpEl) bpEl.textContent = '+' + formatCents(parseInt(bundleChk.getAttribute('data-acc-price'), 10) || 0);
    }
    var others = bundleOthers();
    var wasEl = root.querySelector('[data-npwmp-bundle-was]');
    if (wasEl) {
      var was = 0;
      others.forEach(function (c) {
        var p = parseInt(c.getAttribute('data-acc-price'), 10) || 0;
        was += p * (c.hasAttribute('data-acc-window-qty') ? windowCount() : 1);
      });
      var price = parseInt(bundleChk.getAttribute('data-acc-price'), 10) || 0;
      if (was > price) { wasEl.textContent = formatCents(was); wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }
    var on = bundleChk.checked;
    // The upgrade-swap card is NOT part of the bundle; while the bundle is on,
    // this class reveals its "not included" note (CSS .ua-swap-note).
    var accWrap = bundleChk.closest('.upsell-acc');
    if (accWrap) accWrap.classList.toggle('ua-bundle-on', on);
    others.forEach(function (c) {
      var card = c.closest('.ua-card');
      if (!card) return;
      if (on) {
        if (!card.classList.contains('is-bundled')) {
          c.setAttribute('data-bundle-prev', c.checked ? '1' : '0');
          c.setAttribute('data-bundle-prev-qty', c.getAttribute('data-acc-qty') || '');
          c.checked = false;
          card.classList.add('is-bundled');
        }
        // Opener always displays the full roof-window count while bundled
        // (re-applied every render so size switches keep it in sync).
        if (c.hasAttribute('data-acc-window-qty')) c.setAttribute('data-acc-qty', windowCount());
      } else if (card.classList.contains('is-bundled')) {
        c.checked = c.getAttribute('data-bundle-prev') === '1';
        var pq = c.getAttribute('data-bundle-prev-qty');
        if (pq) c.setAttribute('data-acc-qty', pq);
        card.classList.remove('is-bundled');
      }
    });
  }

  // Quantity-scaled accessories (the window opener): clamp the qty to the roof-window
  // count, refresh the "up to N" label, the stepper bounds and the +$ price.
  // Generic quantity-enabled accessories (schema toggle): no window clamp, capped at 99.
  function updateQtySelectors() {
    root.querySelectorAll('[data-acc-qty-sel]').forEach(function (chk) {
      var card = chk.closest('.ua-card');
      if (!card) return;
      var qty = parseInt(chk.getAttribute('data-acc-qty'), 10) || 1;
      var qtyEl = card.querySelector('[data-npwmp-opener-qty]');
      var priceEl = card.querySelector('[data-npwmp-opener-price]');
      var minusEl = card.querySelector('.ua-minus');
      var plusEl = card.querySelector('.ua-plus');
      if (qtyEl) qtyEl.textContent = qty;
      var unit = parseInt(chk.getAttribute('data-acc-price'), 10) || 0;
      if (priceEl && unit > 0) priceEl.textContent = '+' + formatCents(unit * qty);
      if (minusEl) minusEl.disabled = qty <= 1;
      if (plusEl) plusEl.disabled = qty >= 99;
    });
  }

  function updateOpeners() {
    var max = windowCount();
    root.querySelectorAll('[data-acc-window-qty]').forEach(function (chk) {
      var card = chk.closest('.ua-card');
      if (!card) return;
      // Only offer the quantity stepper when more than one window is available.
      card.classList.toggle('ua-no-qty', max <= 1);
      var qty = parseInt(chk.getAttribute('data-acc-qty'), 10) || 1;
      if (qty > max) qty = max;
      if (qty < 1) qty = 1;
      chk.setAttribute('data-acc-qty', qty);
      var qtyEl = card.querySelector('[data-npwmp-opener-qty]');
      var maxEl = card.querySelector('[data-npwmp-opener-max]');
      var priceEl = card.querySelector('[data-npwmp-opener-price]');
      var minusEl = card.querySelector('.ua-minus');
      var plusEl = card.querySelector('.ua-plus');
      if (qtyEl) qtyEl.textContent = qty;
      if (maxEl) maxEl.textContent = max;
      // Bundle tooltip gallery: keep the openers' x-count badge on the live window count.
      root.querySelectorAll('[data-ig-bi-qty]').forEach(function (b) { b.textContent = '×' + max; });
      var unit = parseInt(chk.getAttribute('data-acc-price'), 10) || 0;
      if (priceEl && unit > 0) priceEl.textContent = '+' + formatCents(unit * qty);
      if (minusEl) minusEl.disabled = qty <= 1;
      if (plusEl) plusEl.disabled = qty >= max;
    });
  }

  // "N roof window(s)" copy in the width-note.
  function updateWindowsNote() {
    var n = windowCount();
    var word = n === 1 ? ' roof window' : ' roof windows';
    root.querySelectorAll('[data-npwmp-windows]').forEach(function (el) { el.textContent = n + word; });
  }

  // Variant-picker dimension note: swap the line to the active option's note (each
  // option button carries its own note in data-npwmp-dimnote). No-op for the colour
  // selector, which has a single static note and no output element.
  function updateDimNote() {
    var out = root.querySelector('[data-npwmp-dimnote-out]');
    if (!out) return;
    var b = root.querySelector('[data-npwmp-size].active');
    if (b && b.hasAttribute('data-npwmp-dimnote')) out.innerHTML = b.getAttribute('data-npwmp-dimnote');
  }

  // Disable length boxes with no available variant for the current width.
  function updateLengthAvailability() {
    if (!DATA.hasWidth) return;
    var list = variants(state.fulfillment);
    var w = currentWidthValue();
    sizeBtns.forEach(function (btn) {
      var l = btn.getAttribute('data-lvalue');
      var match = null;
      for (var i = 0; i < list.length; i++) { if (list[i].w === w && list[i].l === l) { match = list[i]; break; } }
      btn.disabled = !!(match && !match.available);
    });
  }

  function render() {
    // The selected option as a hook for CSS (e.g. the red LIMITED STOCK eyebrow only shows for Buy now).
    root.setAttribute('data-fulfillment', IS_SWAPPED ? 'instock' : (state.fulfillment || ''));
    updateLengthAvailability();
    updateWindowsNote();
    updateDimNote();
    // Add-on shed card: keep its cart variant + price on the selected colour.
    var addonChk = root.querySelector('[data-npwmp-addon]');
    if (addonChk) {
      var av = addonVariantFor();
      if (av) { addonChk.value = av.id; addonChk.setAttribute('data-acc-price', av.price); addonChk.setAttribute('data-acc-preorder-variant', av.pre ? String(av.pre) : ''); }
      var apEl = root.querySelector('[data-npwmp-addon-price]');
      if (apEl && av) apEl.textContent = '+' + formatCents(av.price);
      var aDead = !av || !av.available;
      addonChk.disabled = aDead; if (aDead) addonChk.checked = false;
      var aCard = addonChk.closest('.ua-card'); if (aCard) aCard.classList.toggle('ua-card--disabled', aDead);
    }
    var altPriceEl = root.querySelector('[data-npwmp-alt-price]');
    if (altPriceEl) { var altV = altVariantFor(); if (altV) altPriceEl.textContent = formatCents(altV.price); }
    updateBundle();
    updateOpeners();
    updateQtySelectors();
    var v = activeVariant();
    var addOn = accessoriesTotal();

    // Upgrade-swap card: the price pill always shows the live difference to the
    // swap product's matching variant; while ticked, that variant becomes the
    // one being priced and purchased (the base product never enters the cart).
    var swapChk = root.querySelector('[data-npwmp-prodswap]');
    var swTarget = swapChk ? swapVariantFor() : null;
    if (swapChk) {
      var swPriceEl = root.querySelector('[data-npwmp-swap-price]');
      var swDiff = (swTarget && v) ? swTarget.price - v.price : 0;
      if (swPriceEl) swPriceEl.textContent = swDiff > 0 ? '+' + formatCents(swDiff) : '';
      var swDead = !swTarget || !swTarget.available;
      swapChk.disabled = swDead;
      if (swDead) swapChk.checked = false;
      var swCard = swapChk.closest('.ua-card');
      if (swCard) swCard.classList.toggle('ua-card--disabled', swDead);
    }
    var eff = (swapChk && swapChk.checked && swTarget) ? swTarget : v;

    var nowEl = root.querySelector('[data-npwmp-price-now]');
    var oldEl = root.querySelector('[data-npwmp-price-old]');
    var saveEl = root.querySelector('[data-npwmp-save]');
    var nowCents = eff ? eff.price + addOn : 0;
    if (nowEl) nowEl.textContent = eff ? formatCents(nowCents) : '';
    // band tokens [price] / [base] / [saving] / [saving_pct] follow the selected variant (ygh-stock-schedule.js reads data-ygh-stock-vars)
    try { root.setAttribute('data-ygh-stock-vars', JSON.stringify({ '[price]': eff ? formatCents(eff.price) : '', '[base]': eff ? formatCents(eff.compare > eff.price ? eff.compare : eff.price) : '', '[saving]': eff && eff.compare > eff.price ? formatCents(eff.compare - eff.price) : '', '[saving_pct]': eff && eff.compare > eff.price ? (Math.round((eff.compare - eff.price) / eff.compare * 100) + '%') : '' })); if (window.yghStockApply) window.yghStockApply(); } catch (e) {}
    if (oldEl) oldEl.textContent = eff && eff.compare > eff.price ? formatCents(eff.compare + addOn) : '';
    if (saveEl) {
      if (eff && eff.compare > eff.price) { saveEl.style.display = ''; saveEl.textContent = 'Save ' + formatWhole(eff.compare - eff.price); }
      else { saveEl.style.display = 'none'; }
    }


    ['instock', 'preorder'].forEach(function (key) {
      var fv = variantFor(key);
      var fNow = root.querySelector('[data-npwmp-fo-now="' + key + '"]');
      var fOld = root.querySelector('[data-npwmp-fo-old="' + key + '"]');
      if (fNow) fNow.textContent = fv ? formatCents(fv.price + addOn) : '';
      if (fOld) fOld.textContent = fv && fv.compare > fv.price ? formatCents(fv.compare + addOn) : '';
    });

    var widthLbl = root.querySelector('[data-npwmp-width-value]');
    if (widthLbl) { var wb = activeWidthBtn(); var wv = wb && (wb.querySelector('.size-val') || wb.querySelector('.color-name')); var wvf = wv && wv.querySelector('.cn-full'); if (wvf) wv = wvf; widthLbl.textContent = wv ? wv.textContent : (wb ? wb.getAttribute('data-wvalue') || '' : ''); }

    var lblEl = root.querySelector('[data-npwmp-length-value]');
    if (lblEl) {
      var activeBtn = activeLengthBtn();
      var valEl = activeBtn && activeBtn.querySelector('.size-val');
      lblEl.textContent = valEl ? valEl.textContent : (v ? v.l : '');
    }

    var labelEl = root.querySelector('[data-npwmp-cta-label]');
    var noteEl = root.querySelector('[data-npwmp-cta-note]');
    var input = root.querySelector('[data-npwmp-variant-input]');
    var cta = root.querySelector('[data-npwmp-cta]');
    var framingKey = IS_SWAPPED ? 'instock' : state.fulfillment;
    if (labelEl) labelEl.textContent = (DATA.ctaLabels && DATA.ctaLabels[framingKey]) || 'Add to cart';
    if (labelEl && DATA.ctaShowPrice && eff) labelEl.textContent += (OFFER_LOOK ? ' - ' : ' — ') + formatCents(Math.max(0, nowCents - (DATA.autoDiscount || 0))); // block setting: live total on the button
    // offer look (VSL page v2): the list price crossed out inside the button, after the total
    if (labelEl && OFFER_LOOK && DATA.ctaShowPrice && eff && eff.compare > eff.price) { var cw = document.createElement('s'); cw.className = 'cta-was'; cw.textContent = formatCents(eff.compare + addOn); labelEl.appendChild(document.createTextNode(' ')); labelEl.appendChild(cw); }
    if (noteEl) noteEl.innerHTML = (DATA.notes && DATA.notes[framingKey]) || '';
    if (input) input.value = eff ? eff.id : '';
    if (cta) {
      var ok = eff && eff.available;
      cta.disabled = !ok;
      if (!ok && labelEl) labelEl.textContent = eff ? 'Sold out' : 'Unavailable';
      var stS = window.yghStock; if (stS && stS.soldOut && !root.querySelector('[data-npwmp-fulfill][value="instock"]')) { cta.disabled = true; cta.classList.add('is-soldout'); if (labelEl) labelEl.textContent = 'SOLD OUT'; } // single-product mode
    }
  }

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      sizeBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('active'); btn.setAttribute('aria-pressed', 'true');
      state.index = parseInt(btn.dataset.index, 10);
      render();
    });
  });

  widthBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      widthBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('active'); btn.setAttribute('aria-pressed', 'true');
      state.widthIndex = parseInt(btn.dataset.windex, 10);
      render();
    });
  });

  fulfillRadios.forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) { state.fulfillment = r.value; render(); } });
  });

  // ---- Buy-now sold out (availability cycle, ygh-stock-schedule.js) ----
  // In a sold-out phase the in-stock option is greyed out with a SOLD OUT tag and cannot be picked;
  // the pre-order option takes over. window.yghStock is set by the schedule script (may load later).
  function applyStockPhase() {
    var st = window.yghStock; if (!st) return;
    var r = root.querySelector('[data-npwmp-fulfill][value="instock"]');
    if (!r) { // single-product mode (no in-stock/pre-order pair): the one button turns into "Sold out"
      var so1 = !!st.soldOut, cta1 = root.querySelector('[data-npwmp-cta]'), lab1 = cta1 && cta1.querySelector('[data-npwmp-cta-label]');
      if (cta1) { cta1.disabled = so1; cta1.classList.toggle('is-soldout', so1); if (lab1) { if (so1) { if (!lab1.hasAttribute('data-cta-was')) lab1.setAttribute('data-cta-was', lab1.textContent); lab1.textContent = 'SOLD OUT'; } else if (lab1.hasAttribute('data-cta-was')) { lab1.textContent = lab1.getAttribute('data-cta-was'); lab1.removeAttribute('data-cta-was'); } } }
      var lead1 = root.querySelector('[data-npwmp-soldout-lead]'); if (lead1) lead1.hidden = !so1;
      if (so1) { var pt1 = root.querySelector('.promo-title'), pl1 = root.querySelector('.promo-offer'); if (pt1 && st.title) pt1.textContent = st.title; if (pl1 && st.line) pl1.textContent = st.line; }
      return;
    }
    var card = r.closest('.fulfill-opt'); var so = !!st.soldOut && !IS_SWAPPED;
    r.disabled = so; if (card) card.classList.toggle('fo-soldout', so);
    if (so) {
      var tag = card && card.querySelector('.fo-stock');
      if (tag && !tag.hasAttribute('data-soldout-done')) { tag.setAttribute('data-soldout-done', '1'); tag.innerHTML = '<span class="cta-hl">Sold out</span>'; }
      // the offer band carries the phase's own copy (schedule JSON: "title" / "line") instead of "0 units at 0% off"
      var pt = root.querySelector('.promo-title'), pl = root.querySelector('.promo-offer');
      if (pt && st.title) pt.textContent = st.title;
      if (pl && st.line) pl.textContent = st.line;
      if (state.fulfillment === 'instock') { var po = root.querySelector('[data-npwmp-fulfill][value="preorder"]'); if (po) { po.checked = true; state.fulfillment = 'preorder'; render(); } }
    }
  }
  applyStockPhase();
  document.addEventListener('ygh:stock', applyStockPhase);
  // Stars-line reviews link with an in-page target (#reviews): smooth scroll under the sticky header instead of a hard jump
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.reviews-link[href^="#"]'); if (!a) return;
    var target = document.querySelector(a.getAttribute('href')); if (!target) return;
    e.preventDefault();
    var hdr = document.querySelector('.shopify-section-header, .section-header'); var off = (hdr ? hdr.offsetHeight : 0) + 12;
    var goTo = function (smooth) { var y = target.getBoundingClientRect().top + window.pageYOffset - off; try { window.scrollTo({ top: y < 0 ? 0 : y, behavior: smooth ? 'smooth' : 'auto' }); } catch (err) { window.scrollTo(0, y); } };
    goTo(true);
    // sections above the reviews grow while they lazy-load (owner videos, galleries), so re-aim until the target sits under the header
    [900, 1600, 2600, 4000].forEach(function (ms) { setTimeout(function () { if (Math.abs(target.getBoundingClientRect().top - off) > 40) goTo(false); }, ms); });
  });

  // ---- accessory upsells: live-update prices when toggled ----
  root.querySelectorAll('[data-npwmp-accessory]').forEach(function (chk) {
    chk.addEventListener('change', render);
  });
  root.querySelectorAll('[data-npwmp-prodswap]').forEach(function (chk) {
    chk.addEventListener('change', render);
  });

  // ---- window-opener quantity steppers (don't toggle the card's checkbox) ----
  root.querySelectorAll('[data-npwmp-opener-step]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var card = btn.closest('.ua-card');
      var chk = card && card.querySelector('[data-acc-window-qty], [data-acc-qty-sel]');
      if (!chk) return;
      var max = chk.hasAttribute('data-acc-window-qty') ? windowCount() : 99;
      var qty = parseInt(chk.getAttribute('data-acc-qty'), 10) || 1;
      qty = Math.min(max, Math.max(1, qty + (parseInt(btn.getAttribute('data-npwmp-opener-step'), 10) || 0)));
      chk.setAttribute('data-acc-qty', qty);
      render();
    });
  });

  // ---- accessory info tooltips (tap-safe: don't toggle the Add checkbox) ----
  var infoBtns = Array.prototype.slice.call(root.querySelectorAll('.ua-info'));
  var tipHoverable = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  // Accessory / info tooltips: on phones and tablets shift the bubble just enough to stay inside a 12px gutter.
  function clampTip(info) {
    // Accessory tips are centered on their (i) dot; a dot near the card edge
    // pushes the bubble out of the viewport on phones, so clamp those too -
    // but only on phones, desktop accessory tips are fine as-is.
    if (!(window.matchMedia && window.matchMedia('(max-width: 1099px)').matches)) return; // phones AND tablets: the buybox sits against the right edge there too
    var tip = info.querySelector('.ua-tip');
    if (!tip) return;
    tip.style.marginLeft = '';
    tip.style.setProperty('--tip-arrow-x', '');
    var vw = document.documentElement.clientWidth;
    // Centered bubble: shift it just enough to stay inside a 12px gutter and
    // point the arrow back at the dot (the ::after reads --tip-arrow-x).
    var tr = tip.getBoundingClientRect();
    if (!tr.width) return;
    var dr = info.getBoundingClientRect();
    var shift = 0;
    if (tr.left < 12) shift = 12 - tr.left;
    else if (tr.right > vw - 12) shift = (vw - 12) - tr.right;
    if (shift) tip.style.marginLeft = shift + 'px';
    var ax = (dr.left + dr.width / 2) - (tr.left + shift);
    tip.style.setProperty('--tip-arrow-x', Math.max(14, Math.min(tr.width - 14, ax)) + 'px');
  }
  window.addEventListener('resize', function () {
    root.querySelectorAll('.ua-info.open, .ua-info.hover-open').forEach(clampTip);
  });
  infoBtns.forEach(function (info) {
    info.addEventListener('click', function (e) {
      // A link inside the tooltip (e.g. the swap card's Read more) must navigate:
      // stop the label from toggling the checkbox, but keep the default.
      if (e.target.closest && e.target.closest('[data-npwmp-buy-alone]')) { e.preventDefault(); e.stopPropagation(); return; }
      if (e.target.closest && e.target.closest('.ua-tip__link')) { e.stopPropagation(); return; }
      e.preventDefault(); e.stopPropagation();
      var isOpen = info.classList.contains('open');
      infoBtns.forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) {
        info.classList.remove('is-suppressed');
        info.classList.add('open');
        clampTip(info);
      } else {
        // Second click closes for real: drop focus and suppress the hover
        // reveal until the pointer leaves, or :hover / :focus-within would
        // keep the tip visible after .open is removed.
        if (info.blur) info.blur();
        info.classList.add('is-suppressed');
      }
    });
    info.addEventListener('mouseleave', function () { info.classList.remove('is-suppressed'); });
    // Desktop: :hover alone drops the tip the instant the pointer crosses the
    // gap between the (i) icon and the bubble, so the See more link was
    // unreachable except straight up. hover-open holds the tip through a short
    // grace window; reaching the bubble re-enters .ua-info (the bubble is its
    // DOM child), which fires mouseenter again and cancels the pending close.
    if (tipHoverable) {
      var graceT = null;
      info.addEventListener('mouseenter', function () {
        if (graceT) { clearTimeout(graceT); graceT = null; }
        if (!info.classList.contains('is-suppressed')) info.classList.add('hover-open');
      });
      info.addEventListener('mouseleave', function () {
        if (graceT) clearTimeout(graceT);
        graceT = setTimeout(function () { info.classList.remove('hover-open'); graceT = null; }, 350);
      });
    }
  });
  if (infoBtns.length) {
    // Capture phase: on touch devices a tap outside an open tooltip must ONLY
    // dismiss it - swallow the event so the same tap can't also hit a variant
    // selector or checkbox underneath. Desktop keeps click-through.
    document.addEventListener('click', function (e) {
      var anyOpen = false;
      infoBtns.forEach(function (i) { if (i.classList.contains('open')) anyOpen = true; });
      if (!anyOpen) return;
      if (e.target.closest && e.target.closest('.ua-info')) return;
      infoBtns.forEach(function (i) { i.classList.remove('open'); });
      if (!tipHoverable) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') infoBtns.forEach(function (i) { i.classList.remove('open'); }); });
  }

  // ---- Intelligems upsell-test events: tooltip views + Add ticks ----
  // Every tooltip in the accessories block (data-ig-tip) fires upsellTipView_<key>
  // when it is revealed (hover on desktop, tap-open on touch; throttled so hover
  // jitter doesn't double-count). Every Add tick (data-ig-add, checked only)
  // fires upsellAdd_<key>. Keys: acc1..acc8, bundle, swap. Pushed to igEvents
  // (Intelligems custom events) and dataLayer.
  function igUpsellEvent(name) {
    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: name });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name });
    } catch (e) {}
  }
  root.querySelectorAll('.upsell-acc .ua-info[data-ig-tip]').forEach(function (info) {
    var key = info.getAttribute('data-ig-tip');
    var last = 0;
    function seen() {
      var now = Date.now();
      if (now - last < 800) return;
      last = now;
      igUpsellEvent('upsellTipView_' + key);
    }
    if (tipHoverable) info.addEventListener('mouseenter', seen);
    info.addEventListener('focusin', seen);
    info.addEventListener('click', function () {
      if (info.classList.contains('open')) seen();
    });
  });
  root.querySelectorAll('.upsell-acc .ua-check[data-ig-add]').forEach(function (chk) {
    chk.addEventListener('change', function () {
      if (chk.checked) igUpsellEvent('upsellAdd_' + chk.getAttribute('data-ig-add'));
    });
  });
  // Preview hook for the tooltip test variant without Intelligems:
  // ?ua-bundle-tip=1 shows the What's-inside gallery (same pattern as ?ygh-variant=b).
  if (/[?&]ua-bundle-tip=1/.test(window.location.search)) {
    var sec = root.querySelector('.npwmp-hero-section') || root;
    sec.classList.add('ua-tip-preview');
  }

  // ---- accessories "show more" / "show less" toggle ----
  root.querySelectorAll('[data-npwmp-acc-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.upsell-acc');
      if (!wrap) return;
      var expanded = wrap.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = btn.querySelector('[data-npwmp-acc-more-label]');
      if (label) label.textContent = expanded ? 'Show less' : 'Show more';
    });
  });

  // ---- gallery + lightbox (images + native video) ----
  (function () {
    var stage = root.querySelector('[data-npwmp-stage]');
    var mediaEl = root.querySelector('[data-npwmp-media="' + sid + '"]');
    if (!stage || !mediaEl) return;
    // Out-of-stock: blur + SOLD OUT stamp apply to the first image only. Liquid renders
    // .is-oos-first for MEDIA[0]; toggle it off/on as the shopper navigates the gallery.
    var galleryMain = root.querySelector('.gallery-main');
    var OOS = galleryMain && galleryMain.classList.contains('is-oos');
    var MEDIA = [];
    try { MEDIA = JSON.parse(mediaEl.textContent); } catch (e) { MEDIA = []; }
    if (!MEDIA.length) return;

    var total = MEDIA.length;
    var idx = 0;
    var stageSwiped = false; // set true by a mobile swipe so the tap-to-open handler is skipped
    var userPaused = false;  // true only after the shopper taps the corner pause control
    var vToggle = null;      // lower-right play/pause button, created once below

    // ---- image preloading for snappy gallery + lightbox navigation ----
    // The inline gallery shows the smaller "main" image; the lightbox shows the
    // 1600px "full" image. Preloading the relevant resolution ahead of time means
    // next/prev (and thumbnail jumps) are served from cache, not a cold fetch.
    var preloaded = { main: {}, full: {} };
    function preload(i, res) {
      if (total < 2) return;
      i = (i + total) % total;
      var bag = preloaded[res];
      if (bag[i]) return;
      var it = MEDIA[i];
      if (!it || it.type !== 'image') return;
      var url = res === 'full' ? it.full : (it.main || it.full);
      if (!url) return;
      var im = new Image();
      im.decoding = 'async';
      im.src = url;
      bag[i] = im;
    }
    function preloadNeighbors(res) { preload(idx + 1, res); preload(idx - 1, res); }
    // Background-prefetch every remaining image of the given resolution, radiating
    // out from the current one, at idle priority so it never competes with the active view.
    function preloadAllIdle(res) {
      var order = [], i;
      for (i = 1; i < total; i++) { order.push(idx + i); order.push(idx - i); }
      function run() { if (order.length) { preload(order.shift(), res); schedule(); } }
      function schedule() {
        if (window.requestIdleCallback) { requestIdleCallback(run, { timeout: 600 }); }
        else { setTimeout(run, 80); }
      }
      schedule();
    }

    var prev = root.querySelector('.gallery-prev');
    var next = root.querySelector('.gallery-next');
    var count = root.querySelector('.gallery-count');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-thumb]'));
    var vbadge = root.querySelector('[data-npwmp-vbadge]'); // corner "watch video" circle — first slide only
    var cue = root.querySelector('[data-npwmp-cue]');       // phone swipe cue over the first photo: gone for good after the first slide change

    // lightbox refs
    var lb       = root.querySelector('[data-npwmp-lightbox]');
    var lbMain   = root.querySelector('[data-npwmp-lightbox-main]');
    var lbStage  = root.querySelector('[data-npwmp-lightbox-stage]');
    var lbCount  = root.querySelector('[data-npwmp-lightbox-count]');
    var lbClose  = root.querySelector('[data-npwmp-lightbox-close]');
    var lbPrev   = root.querySelector('[data-npwmp-lightbox-prev]');
    var lbNext   = root.querySelector('[data-npwmp-lightbox-next]');
    var lbThumbs = root.querySelector('[data-npwmp-lightbox-thumbs]');

    // Robustly start a muted video. play() is often called before the media has
    // buffered (we preload only metadata), and that promise rejects on several
    // engines — the old code swallowed it and never retried, which is why the
    // gallery video "sometimes" failed to autoplay. Retry when it can actually
    // start, and again if playback is still refused.
    function forcePlay(v) {
      if (!v) return;
      var attempt = function () {
        if (!v.isConnected) return;
        v.muted = true; // policy needs muted true at the moment of the call
        var p;
        try { p = v.play(); } catch (e) { return; }
        if (p && p.catch) p.catch(function () {});
      };
      attempt();
      v.addEventListener('loadeddata', attempt, { once: true });
      v.addEventListener('canplay', attempt, { once: true });
    }

    // Build an <img> or autoplay-ready <video> for a media item.
    function makeMedia(item, opts) {
      opts = opts || {};
      if (item.type === 'video' && item.src) {
        var v = document.createElement('video');
        if (opts.cls) v.className = opts.cls;
        v.src = item.src;
        if (item.full) v.poster = item.full;
        // Muted + inline is what unlocks autoplay under browser policy. Set them
        // as ATTRIBUTES (not just properties) and before play() is ever called —
        // iOS Safari only honours the attributes.
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.loop = true;
        // Inline gallery reads as a clean looping clip (no player chrome); the
        // fullscreen lightbox keeps controls so the shopper can pause / scrub.
        v.controls = (opts.cls === 'lightbox-img');
        v.preload = 'metadata';
        if (opts.autoplay) {
          v.autoplay = true;
          forcePlay(v);
        }
        return v;
      }
      var img = document.createElement('img');
      if (opts.cls) img.className = opts.cls;
      img.decoding = 'async';
      // Lightbox needs the full-res image; the inline gallery only needs the smaller "main".
      if (opts.cls === 'lightbox-img') { img.src = item.full; img.fetchPriority = 'high'; }
      else { img.src = item.main || item.full; }
      img.alt = item.alt || '';
      return img;
    }
    function stopVideos(container) {
      if (!container) return;
      container.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    }
    function renderStage(autoplay) {
      stopVideos(stage);
      var item = MEDIA[idx];
      var el = makeMedia(item, { cls: 'hero-main', autoplay: autoplay && item.type === 'video' });
      stage.innerHTML = '';
      stage.appendChild(el);
      if (item.type === 'video') {
        el.addEventListener('play', syncVideoUI);
        el.addEventListener('pause', syncVideoUI);
      }
      syncVideoUI();
    }

    // Reflect the current slide's video state on the corner control. The button
    // (and its bottom-right slot) exist only while a video slide is showing.
    function syncVideoUI() {
      var v = stage.querySelector('video');
      var isVideo = !!v;
      if (galleryMain) galleryMain.classList.toggle('is-video-active', isVideo);
      if (!vToggle || !isVideo) return;
      vToggle.classList.toggle('is-paused', v.paused);
      vToggle.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    }
    function syncThumbs() {
      thumbs.forEach(function (t) { t.classList.toggle('active', parseInt(t.dataset.index, 10) === idx); });
    }

    // Keep the active thumb in view in the single-row strip (centred when possible).
    // Scrolls ONLY the strip itself: scrollIntoView({inline:'center'}) also scrolls
    // every scrollable ancestor, and on phones that dragged the whole page sideways
    // when a colour pick swapped the gallery image.
    function centerInStrip(strip, el) {
      if (!strip || !el) return;
      // layout v2: the thumbnails are a column left of the image, so the strip scrolls vertically
      if (strip.scrollHeight > strip.clientHeight + 1 && strip.scrollWidth <= strip.clientWidth + 1) {
        var top = el.getBoundingClientRect().top - strip.getBoundingClientRect().top
          + strip.scrollTop - (strip.clientHeight - el.offsetHeight) / 2;
        strip.scrollTop = Math.max(0, Math.min(top, strip.scrollHeight - strip.clientHeight));
        return;
      }
      if (strip.scrollWidth <= strip.clientWidth + 1) return;
      var left = el.getBoundingClientRect().left - strip.getBoundingClientRect().left
        + strip.scrollLeft - (strip.clientWidth - el.offsetWidth) / 2;
      strip.scrollLeft = Math.max(0, Math.min(left, strip.scrollWidth - strip.clientWidth));
    }
    function scrollThumbIntoView() {
      var t = thumbs[idx];
      if (t) centerInStrip(t.parentNode, t);
    }

    function show(i, autoplay) {
      idx = (i + total) % total;
      // Landing on a video slide is a fresh intent to autoplay, so clear any
      // earlier manual pause.
      if (MEDIA[idx] && MEDIA[idx].type === 'video') userPaused = false;
      renderStage(autoplay !== false);
      preloadNeighbors('main');
      syncThumbs();
      scrollThumbIntoView();
      if (prev) prev.classList.toggle('is-hidden', idx === 0);
      if (OOS) galleryMain.classList.toggle('is-oos-first', idx === 0);
      if (vbadge) vbadge.classList.toggle('is-slide-hidden', idx !== 0);
      if (cue && idx !== 0) { cue.classList.add('is-hidden'); cue = null; }
      if (count) count.textContent = (idx + 1) + ' / ' + total;
      if (lb && !lb.hidden) renderLightbox();
      if (GV) GV.sync(lb && !lb.hidden ? -1 : idx);   // tour video slide: start with sound on arrival, stop on leaving
    }

    // ---- product tour video as a gallery slide (section setting gallery_vsl) ----
    // MEDIA carries one item of type "vsl" (Liquid puts it at index 1). The stage shows its poster; this module lays a Wistia
    // player over the stage and starts it WITH SOUND when the shopper lands on the slide: arrow click, swipe and thumbnail tap are
    // all user gestures, so browsers allow audio as long as play() runs inside them. That is why the player is created ahead of
    // time (idle / first touch of the gallery): a player that still has to load when the click comes may start too late for the
    // gesture, in which case it plays muted and a "Tap for sound" pill appears.
    // Phones (separate 9:16 cut): the stage grows to the full vertical video, thumbnails and the tour row hide, Wistia's own
    // controls stay. Desktop: 16:9 cropped to the square stage with our own minimal controls; the animated expand button hands the
    // playback over to the tour pop-up at the same second and takes it back when the pop-up closes.
    var GV = (function () {
      if (!galleryMain || !galleryMain.hasAttribute('data-gvsl')) return null;
      var vi = -1;
      for (var gi = 0; gi < MEDIA.length; gi++) { if (MEDIA[gi].type === 'vsl') { vi = gi; break; } }
      if (vi < 0) return null;
      var idD = galleryMain.getAttribute('data-gvsl-d'), idM = galleryMain.getAttribute('data-gvsl-m') || idD;
      // width / height of each cut (1 = the square cut, 0.8 = 4:5, 0.5625 = 9:16, 1.78 = the 16:9 tour video cropped to the square)
      var lead = parseFloat(galleryMain.getAttribute('data-gvsl-lead')) || 0;   // the slide's own cut starts this many seconds before the tour video's first frame
      var arD = parseFloat(galleryMain.getAttribute('data-gvsl-ar-d')) || 16 / 9, arM = parseFloat(galleryMain.getAttribute('data-gvsl-ar-m')) || arD;
      var heroLeft = galleryMain.closest('.hero-left') || galleryMain.parentNode;
      var box = document.createElement('div');
      box.className = 'gvsl';
      box.innerHTML =
        '<div class="gvsl__p"></div>' +
        '<button type="button" class="gvsl__hit" aria-label="Pause video"><span class="gvsl__bigplay" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span></button>' +
        '<button type="button" class="gvsl__mute" aria-label="Mute"><svg class="gvsl-ic--on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13"/></svg><svg class="gvsl-ic--off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M16 9l5 6M21 9l-5 6"/></svg></button>' +
        '<button type="button" class="gvsl__expand" aria-label="Watch full screen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path class="gvsl-ar gvsl-ar--a" d="M14 4h6v6M20 4l-7 7"/><path class="gvsl-ar gvsl-ar--b" d="M10 20H4v-6M4 20l7-7"/></svg></button>' +
        '<button type="button" class="gvsl__sound" hidden><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M15.5 8.5a5 5 0 010 7"/></svg>Tap for sound</button>';
      galleryMain.insertBefore(box, stage.nextSibling);
      var slot = box.querySelector('.gvsl__p'), hit = box.querySelector('.gvsl__hit'), muteBtn = box.querySelector('.gvsl__mute'),
          expandBtn = box.querySelector('.gvsl__expand'), soundBtn = box.querySelector('.gvsl__sound');
      // behaviour events (assets/ygh-track.js); key = the slide's Wistia id
      var started = false;
      function tk(name, val, extra) { try { if (window.yghTrack) window.yghTrack(name, galleryMain.getAttribute('data-gvsl-d') || '', val || 0, extra); } catch (e) {} }
      function sec() { try { return Math.round(player.currentTime || 0); } catch (e) { return 0; } }
      var player = null, tall = false, grows = false, native = false, ratio = 16 / 9, active = false, handoff = false, autoPaused = false, userPausedV = false, modalOpen = false, mutedBefore = false;

      function ensure() {
        if (player) return player;
        var phone = window.matchMedia('(max-width: 768px)').matches;
        ratio = phone ? arM : arD;
        tall = phone && ratio <= 0.6;            // 9:16 cut: the gallery takes the whole screen height
        grows = ratio < 1 && !tall;              // 4:5 cut: the stage grows to the video's height (desktop and phones), thumbnails and the tour row stay
        native = phone && ratio < 1;             // a cut that is not cropped keeps Wistia's own controls
        box.classList.toggle('gvsl--tall', tall);
        box.classList.toggle('gvsl--native', native);
        player = document.createElement('wistia-player');
        player.setAttribute('media-id', phone ? idM : idD);
        player.setAttribute('aspect', String(ratio));
        player.setAttribute('silent-autoplay', 'false');
        // Wistia starts at its lowest allowed rendition (360p) and stays there; ask for a sharp one from the first frame
        player.setAttribute('quality-min', '720');
        if (!native) {
          player.setAttribute('big-play-button', 'false');   // desktop (square cut or cropped 16:9): Wistia's control bar is off and ours take over
          ['playbar', 'play-pause-control', 'volume-control', 'fullscreen-control', 'settings-control', 'small-play-button', 'controls-visible-on-load'].forEach(function (a) { player.setAttribute(a, 'false'); });
        }
        slot.appendChild(player);
        ['play', 'pause', 'ended', 'mute-change', 'volume-change'].forEach(function (ev) { player.addEventListener(ev, syncUI); });
        layout();
        return player;
      }
      // the player always covers the box: as wide as the box, or wider when the box is taller than the video's ratio
      function layout() {
        if (!player) return;
        var cw = box.clientWidth, ch = box.clientHeight;
        if (!cw || !ch) return;
        slot.style.width = Math.ceil(Math.max(cw, ch * ratio)) + 'px';
      }
      if ('ResizeObserver' in window) new ResizeObserver(layout).observe(box);
      window.addEventListener('resize', layout);

      function state() {
        try {
          if (player && player.tagName === 'VIDEO') return player.ended ? 'ended' : (player.paused ? (player.currentTime > 0 ? 'paused' : 'beforeplay') : 'playing');
          return player.state;
        } catch (e) { return ''; }
      }
      function isMuted() { try { return !!player.muted; } catch (e) { return false; } }
      function syncUI() {
        if (!player) return;
        var st = state(), playing = st === 'playing';
        if (modalOpen && playing) { pause(); try { player.muted = true; } catch (e) {} }   // the pop-up is playing: this one stays still and silent
        box.classList.toggle('is-paused', active && (st === 'paused' || st === 'ended'));
        box.classList.toggle('is-muted', isMuted() && !comp);
        hit.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        muteBtn.setAttribute('aria-label', isMuted() ? 'Unmute' : 'Mute');
        if (!isMuted()) soundBtn.hidden = true;
      }
      function whenReady(fn) {
        if (typeof player.play === 'function') fn();
        else if (window.customElements && customElements.whenDefined) customElements.whenDefined('wistia-player').then(fn).catch(function () {});
      }
      // The player's real <video> sits in its (open) shadow root. Starting THAT element synchronously inside the tap is what
      // phone browsers ask for; Wistia's own play() may only reach the element a moment later, which iOS treats as "no gesture".
      function nativeVideo() { try { if (player && player.tagName === 'VIDEO') return player; return player && player.shadowRoot ? player.shadowRoot.querySelector('video') : null; } catch (e) { return null; } }
      // ---- sound companion ----
      // Phones (iOS above all) only allow sound when play() is called INSIDE the tap, on the element itself. Wistia's <video>
      // does not exist until its player has loaded (seconds after the page), so an early tap could only start the video muted.
      // The tap unlocks an <audio> element instead (a silent clip, played inside the gesture); when the Wistia video then has to
      // start muted, that element plays the video's own sound track (setting gallery_vsl_audio) in step with it. The player
      // stays Wistia: its controls, its tracking. Once the visitor gives Wistia's own sound (its volume button, our mute button)
      // the companion stops for good.
      var audUrl = galleryMain.getAttribute('data-gvsl-audio') || '';
      var aud = null, audOK = false, comp = false, compTimer = null;
      var SILENT = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
      function unlockAudio() {
        if (!audUrl || audOK) return;
        if (navigator.userActivation && !navigator.userActivation.isActive) return;   // not a real tap (a swipe): it would be refused
        try {
          if (!aud) { aud = new Audio(); aud.preload = 'none'; }
          aud.muted = false; aud.src = SILENT;
          var done = function () { if (audOK) return; audOK = true; try { aud.pause(); aud.src = audUrl; aud.preload = 'none'; aud.load(); } catch (e) {} };
          var pr = aud.play();
          if (pr && pr.then) pr.then(done, function () {}); else done();
        } catch (e) {}
      }
      galleryMain.__gvslSound = function () { return { unlocked: audOK, on: comp, paused: aud ? aud.paused : null, t: aud ? Math.round((aud.currentTime || 0) * 10) / 10 : null }; };   // for checks
      function stopComp() { comp = false; clearInterval(compTimer); try { if (aud) aud.pause(); } catch (e) {} }
      function syncComp() {
        if (!comp || !aud) return;
        if (!active || modalOpen || !isMuted()) { stopComp(); syncUI(); return; }   // left the slide, or the player has its own sound now
        var t = 0; try { t = player.currentTime || 0; } catch (e) {}
        if (state() === 'playing') {
          if (Math.abs((aud.currentTime || 0) - t) > 0.35) { try { aud.currentTime = t; } catch (e) {} }
          if (aud.paused) { var p = aud.play(); if (p && p.catch) p.catch(function () { stopComp(); soundBtn.hidden = false; syncUI(); }); }
        } else if (!aud.paused) { aud.pause(); }
      }
      function startComp() {
        if (!audOK || !aud) return false;
        if (comp) return true;
        comp = true; soundBtn.hidden = true;
        clearInterval(compTimer); compTimer = setInterval(syncComp, 250); syncComp();
        return true;
      }
      function playMuted() {
        if (modalOpen) return;
        var nv = nativeVideo();
        try { player.muted = true; } catch (e) {}
        if (nv) { nv.muted = true; try { var q = nv.play(); if (q && q.catch) q.catch(function () {}); } catch (e) {} }
        try { var p = player.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
        if (!startComp()) soundBtn.hidden = false;
        syncUI();
      }
      function play(withSound) {
        ensure();
        if (modalOpen) return;   // the tour pop-up is open: nothing starts behind it
        if (withSound !== false) unlockAudio();
        var sound = withSound !== false, nv = nativeVideo();
        if (nv && typeof player.play === 'function') {
          // ready: sound-on start straight from the gesture; a refusal comes back as a rejected promise -> muted + pill
          try { player.muted = !sound; } catch (e) {}
          nv.muted = !sound;
          var pr; try { pr = nv.play(); } catch (e) {}
          if (pr && pr.catch) pr.catch(function () { if (active && sound) playMuted(); });
          try { var p2 = player.play(); if (p2 && p2.catch) p2.catch(function () {}); } catch (e) {}
        } else {
          // not ready yet (tapped right after the page opened): whatever starts later is outside the gesture, so it starts muted
          // the moment it can (muted playback is always allowed) and the pill offers the sound
          whenReady(function () {
            var go = function () { if (!active) return; if (sound && navigator.userActivation && navigator.userActivation.isActive && nativeVideo()) play(true); else playMuted(); };
            try { var w = typeof player.whenApiReady === 'function' ? player.whenApiReady() : player.whenApiReady; if (w && w.then) { w.then(go, go); return; } } catch (e) {}
            go();
          });
        }
        // Wistia may re-mute when the media's own setting is silent autoplay: unmute again while the gesture is still fresh
        [250, 900].forEach(function (ms) { setTimeout(function () { if (active && !modalOpen && sound && !comp && isMuted() && state() === 'playing' && soundBtn.hidden) { try { player.muted = false; var v2 = nativeVideo(); if (v2) v2.muted = false; } catch (e) {} } syncUI(); }, ms); });
        setTimeout(function () { if (active && !modalOpen && !comp && isMuted() && state() === 'playing') soundBtn.hidden = false; syncUI();
          if (active && !started && state() === 'playing') { started = true; tk('gallery_video_start', 0, { sound: isMuted() && !comp ? 0 : 1, companion: comp ? 1 : 0 }); } }, 2400);
        // nothing running after 4 s: start it muted rather than leave a still picture (the pill gives the sound back)
        setTimeout(function () { if (active && !userPausedV && state() !== 'playing') playMuted(); syncUI(); }, 4000);
        setTimeout(function () { if (active && !modalOpen && !userPausedV && state() !== 'playing') box.classList.add('is-paused'); }, 7000);   // nothing would start: show the play button
      }
      function pause() { if (!player) return; try { if (typeof player.pause === 'function') player.pause(); } catch (e) {} }

      // phones: the stage grows from the square to the video's height; the 9:16 cut takes the full screen height and the page lines
      // the gallery up under any fixed header, the 4:5 cut just gets taller in place
      function fixedTop() {
        var el = document.elementFromPoint(Math.round(window.innerWidth / 2), 2), b = 0;
        while (el && el !== document.body) {
          if (galleryMain.contains(el)) return 0;
          var pos = getComputedStyle(el).position;
          if (pos === 'fixed' || pos === 'sticky') b = Math.max(b, el.getBoundingClientRect().bottom);
          el = el.parentElement;
        }
        return Math.max(0, Math.round(b));
      }
      function grow() {
        var w = stage.clientWidth;
        stage.style.height = stage.clientHeight + 'px';
        galleryMain.classList.add(tall ? 'is-gvsl-tall' : 'is-gvsl-grow'); if (tall) heroLeft.classList.add('is-gvsl-tall');
        var fit = function (scroll) {
          if (!active) return;
          if (!tall) { stage.style.height = Math.round(w / ratio) + 'px'; return; }
          var top = fixedTop();
          stage.style.height = Math.round(Math.min(w * 16 / 9, window.innerHeight - top)) + 'px';
          if (scroll) window.scrollTo({ top: Math.max(0, galleryMain.getBoundingClientRect().top + window.pageYOffset - top), behavior: 'smooth' });
        };
        requestAnimationFrame(function () { fit(true); });
        setTimeout(function () { fit(true); }, 650);   // once the scroll has settled a hide-on-scroll header may have come or gone
      }
      function shrink() {
        galleryMain.classList.remove('is-gvsl-tall', 'is-gvsl-grow'); heroLeft.classList.remove('is-gvsl-tall');
        stage.style.height = '';
      }

      var uiTimer = null;
      function activate() {
        if (active) return;
        active = true; userPausedV = false; autoPaused = false; soundBtn.hidden = true;
        clearInterval(uiTimer); uiTimer = setInterval(syncUI, 500);   // Wistia's event names vary by player version: poll the state too
        ensure();
        box.classList.add('is-on'); galleryMain.classList.add('is-gvsl');
        // the Watch Product Tour row has done its job once the video is on screen: it leaves instead of being pushed down by the taller gallery
        heroLeft.classList.remove('is-gvsl-back'); heroLeft.classList.add('is-gvsl-seen');
        if (tall || grows) grow();
        layout(); play(true);
      }
      function deactivate() {
        if (!active) return;
        active = false; stopComp(); pause(); clearInterval(uiTimer);
        box.classList.remove('is-on', 'is-paused'); galleryMain.classList.remove('is-gvsl');
        // on any other slide the Watch Product Tour row comes back (eased in)
        heroLeft.classList.remove('is-gvsl-seen'); heroLeft.classList.add('is-gvsl-back');
        if (tall || grows) shrink();
      }

      // our controls (desktop square)
      hit.addEventListener('click', function () {
        if (state() === 'playing') { userPausedV = true; tk('gallery_video_pause', sec()); pause(); } else { userPausedV = false; play(!isMuted()); }
      });
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (comp) { stopComp(); syncUI(); tk('gallery_video_mute', 1); return; }   // sound was the companion's: this click is "mute"
        try { player.muted = !isMuted(); } catch (err) {}
        tk('gallery_video_mute', isMuted() ? 1 : 0);
        syncUI();
      });
      soundBtn.addEventListener('click', function (e) { e.stopPropagation(); soundBtn.hidden = true; userPausedV = false; tk('gallery_video_sound', sec()); play(true); });
      expandBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var t = 0; try { t = player.currentTime || 0; } catch (err) {}
        handoff = true; tk('gallery_video_expand', Math.round(t)); holdForModal();
        root.dispatchEvent(new CustomEvent('npwmp:vsl-expand', { detail: { time: Math.max(0, t - lead) } }));
      });
      // the tour pop-up opened (expand button or the Watch Product Tour button): never two soundtracks at once
      // (timers and the scroll observer in here would otherwise start it again a few seconds after the hand-off)
      function holdForModal() {
        if (modalOpen) return;
        mutedBefore = isMuted() && !comp;
        modalOpen = true; stopComp(); pause();
        try { if (player) player.muted = true; } catch (e) {}
        var nv = nativeVideo(); if (nv) { try { nv.pause(); nv.muted = true; } catch (e) {} }
      }
      root.addEventListener('npwmp:vmodal-open', holdForModal);
      root.addEventListener('npwmp:vmodal-close', function (e) {
        if (modalOpen) { modalOpen = false; try { if (player) player.muted = mutedBefore; } catch (err) {} syncUI(); }
        if (!active || !handoff) { handoff = false; return; }
        handoff = false;
        var t = e.detail && e.detail.time;
        if (t > 0) t += lead;
        whenReady(function () { try { if (t > 0) player.currentTime = t; } catch (err) {} play(true); });
      });

      // swipe left / right on the video = next / previous slide (the stage's own swipe handler sits under the player)
      var sx = 0, sy = 0, sOn = false;
      box.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; if (!t) return;
        sOn = t.clientY < box.getBoundingClientRect().bottom - 64;   // not on Wistia's control bar: that is scrubbing
        sx = t.clientX; sy = t.clientY;
      }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (!sOn) return; sOn = false;
        var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(dx < 0 ? idx + 1 : idx - 1, false);
      }, { passive: true });

      // scrolled away = pause, back = carry on (unless the shopper paused it)
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          if (!active || !player || modalOpen) return;
          var vis = en[0].intersectionRatio >= 0.3;
          if (!vis && state() === 'playing') { autoPaused = true; pause(); }
          else if (vis && autoPaused) { autoPaused = false; if (!userPausedV) play(!isMuted()); }
        }, { threshold: [0, 0.3, 0.6] }).observe(galleryMain);
      }

      // the player has to be READY when the arrow is pressed (see play()), so it is created right away, like the pop-up's players
      ensure();

      // Sound from a SWIPE. Browsers accept a tap as permission for audio, never a swipe (its touchend is not a "user gesture"),
      // so a swipe onto this slide could only ever start muted. A media element stays unlocked once it was touched inside a real
      // gesture, though: on the visitor's first genuine tap anywhere on the page the video element is load()ed (no playback, no
      // play event, nothing counted), and a later swipe may then start it with sound. A swipe that is the very first interaction
      // still starts muted with the pill: that part is the browser's rule.
      var primed = 0;
      function prime(e) {
        if (primed >= 2 || !player) return;
        if (active || state() !== 'beforeplay') { primed = 9; return; }           // it has played: its own tap unlocked it
        var tg = e.target;
        if (tg && tg.closest && tg.closest('.gallery-arrow, [data-npwmp-thumb], .gvsl')) return;   // these start the video themselves
        if (navigator.userActivation && !navigator.userActivation.isActive) return;   // not accepted as a gesture (a swipe / scroll)
        var nv = nativeVideo();
        if (!nv || String(nv.currentSrc || nv.src || '').indexOf('blob:') === 0) return;
        try { nv.load(); primed++; } catch (err) {}
      }
      ['touchend', 'click', 'keydown'].forEach(function (ev) { document.addEventListener(ev, prime, { capture: true, passive: true }); });
      ['touchend', 'click'].forEach(function (ev) { document.addEventListener(ev, function () { unlockAudio(); }, { capture: true, passive: true }); });

      return { index: vi, sync: function (i) { if (i === vi) activate(); else deactivate(); } };
    })();

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.index, 10)); });
    });
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (cue) cue.addEventListener('click', function () { show(1); });   // the video slide; the gesture lets it start with sound
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    // ---- inline video play/pause control (video slide only) ----
    // Autoplay is best-effort; if the browser blocked it (power-saving mode, a
    // pre-buffer rejection, etc.) the only prior way to start the clip was tapping
    // its thumbnail. This lower-right button gives an obvious control instead.
    if (galleryMain) {
      vToggle = document.createElement('button');
      vToggle.type = 'button';
      vToggle.className = 'gallery-vtoggle';
      vToggle.setAttribute('aria-label', 'Play video');
      vToggle.innerHTML =
        '<svg class="gv-ic gv-ic--play" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' +
        '<svg class="gv-ic gv-ic--pause" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>';
      galleryMain.appendChild(vToggle);
      vToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = stage.querySelector('video');
        if (!v) return;
        if (v.paused) { userPaused = false; forcePlay(v); }
        else { userPaused = true; try { v.pause(); } catch (err) {} }
      });
    }

    // Some browsers refuse autoplay until the visitor interacts with the page at
    // all. On the first interaction anywhere, nudge the active inline video —
    // unless the shopper deliberately paused it.
    function nudgeInlineVideo() {
      if (userPaused) return;
      var v = stage.querySelector('video');
      if (v && v.paused) forcePlay(v);
    }
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (evt) {
      document.addEventListener(evt, nudgeInlineVideo, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) nudgeInlineVideo();
    });

    // ---- variant ↔ gallery sync ----
    // Each colour/model button carries the matching variant's featured-media id
    // (data-npwmp-media). Selecting a variant swaps the main gallery image to it.
    var mediaIndexById = {};
    MEDIA.forEach(function (m, i) { if (m.id != null) mediaIndexById[String(m.id)] = i; });
    function showByMediaId(id) {
      if (!id) return;
      var i = mediaIndexById[String(id)];
      if (i != null && i !== idx) show(i);
    }
    // Only on an actual variant pick — NOT on load. First load deliberately keeps
    // the main gallery image (MEDIA[0]) rather than the default variant's image.
    // Size buttons AND colour buttons bound to the product's other option (data-npwmp-width) swap the gallery.
    root.querySelectorAll('[data-npwmp-size], [data-npwmp-width]').forEach(function (b) {
      b.addEventListener('click', function () { showByMediaId(b.getAttribute('data-npwmp-variant-media')); });
    });

    // Main gallery: swipe left/right on mobile to change the image.
    // A registered swipe sets stageSwiped so the tap-to-open-lightbox handler is skipped.
    (function () {
      var gsX = 0, gsY = 0, gsActive = false, gsMoved = false;
      stage.addEventListener('touchstart', function (e) {
        if (!e.touches[0]) return;
        gsActive = true; gsMoved = false;
        gsX = e.touches[0].clientX; gsY = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (!gsActive || !e.touches[0]) return;
        var dx = e.touches[0].clientX - gsX, dy = e.touches[0].clientY - gsY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) gsMoved = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!gsActive) return;
        gsActive = false;
        var ex = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : gsX;
        var dx = ex - gsX;
        if (gsMoved && Math.abs(dx) > 40) { stageSwiped = true; show(dx < 0 ? idx + 1 : idx - 1, false); }
      }, { passive: true });
    })();

    // ---- lightbox ----
    var resetLightboxZoom = null; // assigned by the zoom module below
    function renderLightbox() {
      if (!lbStage) return;
      if (resetLightboxZoom) resetLightboxZoom();
      stopVideos(lbStage);
      var item = MEDIA[idx];
      unmountLbVideo();
      var isVsl = item.type === 'vsl' && galleryMain && galleryMain.getAttribute('data-lb-d');
      lbStage.classList.toggle('is-video', !!isVsl);
      if (isVsl) { mountLbVideo(); }
      else {
        var el = makeMedia(item, { cls: 'lightbox-img', autoplay: item.type === 'video' });
        lbStage.innerHTML = '';
        lbStage.appendChild(el);
      }
      preloadNeighbors('full');
      if (lbCount) lbCount.textContent = (idx + 1) + ' / ' + total;
      var multi = total > 1;
      if (lbPrev) lbPrev.style.display = multi ? '' : 'none';
      if (lbNext) lbNext.style.display = multi ? '' : 'none';
      if (lbThumbs) {
        Array.prototype.forEach.call(lbThumbs.children, function (c) {
          var on = parseInt(c.dataset.index, 10) === idx;
          c.classList.toggle('active', on);
          if (on) centerInStrip(lbThumbs, c);
        });
      }
    }
    // ---- the tour video inside the full-screen viewer: desktop = the 16:9 cut, phones = the 9:16 cut (the pop-up's media) ----
    // Arriving on the slide is a click or a tap, so the player may start with sound right away.
    var lbVideoEl = null;
    function mountLbVideo() {
      var phone = window.matchMedia('(max-width: 768px)').matches;
      var id = phone ? (galleryMain.getAttribute('data-lb-m') || galleryMain.getAttribute('data-lb-d')) : galleryMain.getAttribute('data-lb-d');
      var ar = parseFloat(phone ? galleryMain.getAttribute('data-lb-ar-m') : galleryMain.getAttribute('data-lb-ar-d')) || (phone ? 0.5625 : 16 / 9);
      lbStage.style.setProperty('--lb-ar', String(ar));
      lbStage.innerHTML = '';
      var pl = document.createElement('wistia-player');
      pl.className = 'lightbox-video';
      pl.setAttribute('media-id', id);
      pl.setAttribute('aspect', String(ar));
      pl.setAttribute('silent-autoplay', 'false');
      pl.setAttribute('quality-min', '720');
      pl.setAttribute('data-npwmp-lbplayer', '');
      lbStage.appendChild(pl);
      lbVideoEl = pl;
      var started = false;
      var go = function () {
        if (started || lbVideoEl !== pl) return; started = true;
        try { var r = pl.play(); if (r && r.catch) r.catch(function () {}); } catch (e) {}
        try { if (window.yghTrack) window.yghTrack('video_play', 'lightbox|' + id, 0, { muted: 0, auto: 0, title: 'full-screen viewer' }); } catch (e) {}
      };
      if (typeof pl.play === 'function') go();
      else if (window.customElements && customElements.whenDefined) customElements.whenDefined('wistia-player').then(go).catch(function () {});
    }
    function unmountLbVideo() {
      if (!lbVideoEl) return;
      try { lbVideoEl.pause(); } catch (e) {}
      if (lbVideoEl.parentNode) lbVideoEl.parentNode.removeChild(lbVideoEl);
      lbVideoEl = null;
      lbStage.classList.remove('is-video');
    }
    function openLightbox() {
      stopVideos(stage);
      renderLightbox();
      preloadAllIdle('full');
      lb.hidden = false;
      document.body.classList.add('drawer-lock');
    }
    function closeLightbox() {
      lb.hidden = true;
      if (resetLightboxZoom) resetLightboxZoom();
      stopVideos(lbStage);
      unmountLbVideo();
      if (!document.querySelector('.acc-drawer.is-open')) document.body.classList.remove('drawer-lock');
      // resume the inline video if the active media is a video
      if (MEDIA[idx] && MEDIA[idx].type === 'video') renderStage(true);
      if (GV) GV.sync(idx);
    }

    // Build the lightbox thumbnail strip from the media list.
    if (lbThumbs) {
      MEDIA.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lightbox-thumb';
        b.dataset.index = i;
        var im = document.createElement('img');
        im.src = item.thumb; im.alt = item.alt || ''; im.loading = 'lazy';
        b.appendChild(im);
        if (item.type === 'video' || item.type === 'vsl') {
          var pl = document.createElement('span');
          pl.className = 'thumb-play';
          pl.setAttribute('aria-hidden', 'true');
          pl.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
          b.appendChild(pl);
        }
        b.addEventListener('click', function () { show(i); });
        lbThumbs.appendChild(b);
      });
    }

    if (lb) {
      // Click the main image (not a video) to open the lightbox.
      stage.addEventListener('click', function (e) {
        if (stageSwiped) { stageSwiped = false; return; }
        if (e.target.closest('video')) return;
        openLightbox();
      });
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
      if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
      // Click the image to zoom into that point; move (desktop) or drag (touch)
      // to pan; click again to zoom out — matching the old gallery modal.
      if (lbStage) {
        var ZOOM = 2;
        var zoomedImg = null;
        var justSwiped = false;
        var clampPct = function (v) { return Math.max(0, Math.min(100, v)); };
        var setOrigin = function (img, ox, oy) { img.style.transformOrigin = clampPct(ox) + '% ' + clampPct(oy) + '%'; };
        var zoomOut = function (img) {
          if (!img) return;
          img.classList.remove('is-zoomed', 'is-panning');
          img.style.transform = '';
          img.style.transformOrigin = '';
          if (zoomedImg === img) zoomedImg = null;
        };
        resetLightboxZoom = function () { if (zoomedImg) zoomOut(zoomedImg); zoomedImg = null; };

        lbStage.addEventListener('click', function (e) {
          var img = e.target.closest && e.target.closest('img.lightbox-img');
          if (!img) return;
          e.stopPropagation();
          if (justSwiped) { justSwiped = false; return; }
          if (img.classList.contains('is-zoomed')) { zoomOut(img); return; }
          var rect = img.getBoundingClientRect();
          setOrigin(img, ((e.clientX - rect.left) / rect.width) * 100, ((e.clientY - rect.top) / rect.height) * 100);
          img.style.transform = 'scale(' + ZOOM + ')';
          img.classList.add('is-zoomed');
          zoomedImg = img;
        });
        // Desktop: hover moves the focal point across the zoomed image.
        lbStage.addEventListener('mousemove', function (e) {
          if (!zoomedImg) return;
          var rect = zoomedImg.getBoundingClientRect();
          setOrigin(zoomedImg, ((e.clientX - rect.left) / rect.width) * 100, ((e.clientY - rect.top) / rect.height) * 100);
        });
        // Touch: drag to pan.
        var tsx = 0, tsy = 0, ox0 = 50, oy0 = 50, panning = false;
        lbStage.addEventListener('touchstart', function (e) {
          if (!zoomedImg || !e.touches[0]) return;
          panning = false;
          tsx = e.touches[0].clientX; tsy = e.touches[0].clientY;
          var parts = (zoomedImg.style.transformOrigin || '50% 50%').split(' ');
          ox0 = parseFloat(parts[0]) || 50; oy0 = parseFloat(parts[1]) || 50;
        }, { passive: true });
        lbStage.addEventListener('touchmove', function (e) {
          if (!zoomedImg || !e.touches[0]) return;
          var dx = e.touches[0].clientX - tsx, dy = e.touches[0].clientY - tsy;
          if (!panning) { if (Math.sqrt(dx * dx + dy * dy) > 10) { panning = true; zoomedImg.classList.add('is-panning'); } else return; }
          if (e.cancelable) e.preventDefault();
          var rect = zoomedImg.getBoundingClientRect();
          setOrigin(zoomedImg, ox0 - (dx / rect.width) * 100, oy0 - (dy / rect.height) * 100);
        }, { passive: false });
        lbStage.addEventListener('touchend', function () { if (zoomedImg) zoomedImg.classList.remove('is-panning'); panning = false; });

        // Swipe left/right to navigate when not zoomed.
        var swX = 0, swY = 0, swActive = false, swMoved = false;
        lbStage.addEventListener('touchstart', function (e) {
          justSwiped = false;
          if (zoomedImg || !e.touches[0]) { swActive = false; return; }
          swActive = true; swMoved = false;
          swX = e.touches[0].clientX; swY = e.touches[0].clientY;
        }, { passive: true });
        lbStage.addEventListener('touchmove', function (e) {
          if (!swActive || zoomedImg || !e.touches[0]) return;
          var dx = e.touches[0].clientX - swX, dy = e.touches[0].clientY - swY;
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) swMoved = true;
        }, { passive: true });
        lbStage.addEventListener('touchend', function (e) {
          if (!swActive || zoomedImg) return;
          swActive = false;
          var ex = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : swX;
          var dx = ex - swX;
          if (swMoved && Math.abs(dx) > 40) { justSwiped = true; show(dx < 0 ? idx + 1 : idx - 1); }
        }, { passive: true });
      }
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target === lbMain || e.target === lbStage) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
    }

    // Initial paint: the server already rendered the first image, so only rebuild
    // the stage when the first item is a video. Otherwise just sync the chrome.
    if (MEDIA[0] && MEDIA[0].type === 'video') renderStage(true);
    syncThumbs();
    if (count) count.textContent = '1 / ' + total;
    if (prev) prev.classList.add('is-hidden');
    // Warm the inline gallery: neighbours now, the rest at idle, so clicking
    // next/prev is served from cache instead of a cold fetch.
    preloadNeighbors('main');
    preloadAllIdle('main');
  })();

  // ---- stars ----
  root.querySelectorAll('.stars').forEach(function (el) {
    var n = parseInt(el.getAttribute('data-stars') || '5', 10);
    var star = '<svg viewBox="0 0 24 24" fill="#159d59"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>';
    el.innerHTML = star.repeat(n);
  });

  // ---- hero review mini-gallery: one slide visible, arrows step through ----
  (function () {
    var wrap = root.querySelector('[data-npwmp-rvb]');
    if (!wrap) return;
    var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-rvb-slide]'));
    if (slides.length < 2) return;   // single review renders static, no arrows exist

    var i = 0;
    function show(next) {
      i = (next + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-on', n === i);
        if (n === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
    }
    var prev = wrap.querySelector('[data-rvb-prev]');
    var next = wrap.querySelector('[data-rvb-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    // Hidden slides sit in display:none, where a loading="lazy" image never comes near
    // the viewport and so is never fetched. The arrow then reveals an <img> that only
    // starts downloading on click, which is the delay. Warm them at idle instead, with
    // the same sizes and srcset so the browser caches the exact candidate the slide will
    // request. Page load itself stays lazy: nothing is fetched until the browser is free.
    function warmOthers() {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (!img || img.getAttribute('data-rvb-warm')) return;
        img.setAttribute('data-rvb-warm', '1');
        var pre = new Image();
        if (img.sizes) pre.sizes = img.sizes;          // set before srcset so selection matches
        if (img.srcset) pre.srcset = img.srcset;
        pre.src = img.src;
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(warmOthers, { timeout: 4000 });
    else setTimeout(warmOthers, 1500);

    // Swipe left/right on touch, matching the gallery and drawers.
    var sx = 0, sy = 0, active = false, moved = false;
    wrap.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      active = true; moved = false;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchmove', function (e) {
      if (!active || !e.touches[0]) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) moved = true;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (!active) return;
      active = false;
      var ex = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : sx;
      var dx = ex - sx;
      if (moved && Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  })();

  // ---- drawers (same proven pattern as the standalone drawer section: one fixed
  //      full-screen host that IS the dim layer, panels slide in from the right,
  //      click the dim / X / Esc to close) ----
  (function () {
    // A single host holds every panel. It's the dim layer itself (its own
    // translucent background) and lives inside the section, at a very high
    // z-index so it sits above the page.
    var host = document.createElement('div');
    host.className = 'npwmp-hero-drawer-host';
    root.appendChild(host);

    var accItems = Array.prototype.slice.call(root.querySelectorAll('[data-npwmp-acc]'));
    var drawers = [];
    accItems.forEach(function (item) {
      var panel = item.querySelector('.acc-drawer');
      if (!panel) return;
      var target = item.getAttribute('data-link-target') || '';
      // The plan gallery travels with its drawer into the fixed host so it can be
      // positioned in the space beside it.
      var plans = item.querySelector('[data-npwmp-plans]');
      host.appendChild(panel);
      if (plans) host.appendChild(plans);
      drawers.push({ panel: panel, target: target, plans: plans, row: item.querySelector('.acc-row') });
    });
    if (!drawers.length) { host.remove(); return; }

    // Plan slides stay lazy so they cost nothing at page load, but lazy +
    // display:none means each arrow press used to fetch its image on demand.
    // Flipping them all to eager the moment their drawer opens fetches the
    // whole set in the background, so navigation is instant.
    function warmPlans(d) {
      if (!d.plans || d.plansWarm) return;
      d.plansWarm = true;
      d.plans.querySelectorAll('[data-npwmp-plan-slide]').forEach(function (im) { im.loading = 'eager'; });
    }
    function resetZoom(plansEl) {
      var st = plansEl.querySelector('.plan-gallery__stage.is-zoomed');
      if (st) { st.classList.remove('is-zoomed'); st.scrollLeft = 0; st.scrollTop = 0; }
    }

    function closeAll() {
      drawers.forEach(function (d) {
        d.panel.classList.remove('is-open'); d.panel.style.transform = '';
        if (d.plans) { d.plans.classList.remove('is-visible', 'is-fullscreen'); resetZoom(d.plans); }
      });
      host.classList.remove('is-open');
      document.body.classList.remove('drawer-lock');
    }
    function openDrawer(d) {
      if (!d) return;
      drawers.forEach(function (x) {
        if (x !== d) {
          x.panel.classList.remove('is-open');
          if (x.plans) x.plans.classList.remove('is-visible', 'is-fullscreen');
        }
      });
      if (d.plans) { d.plans.classList.add('is-visible'); warmPlans(d); }
      host.classList.add('is-open');
      document.body.classList.add('drawer-lock');
      // Next frame so the slide-in transition runs from the off-screen start.
      requestAnimationFrame(function () { d.panel.classList.add('is-open'); });
    }
    function openByTarget(t) {
      for (var i = 0; i < drawers.length; i++) { if (drawers[i].target === t) { openDrawer(drawers[i]); return; } }
    }

    drawers.forEach(function (d) {
      if (d.row) d.row.addEventListener('click', function () {
        d.panel.classList.contains('is-open') ? closeAll() : openDrawer(d);
      });
      var close = d.panel.querySelector('.drawer-close');
      if (close) close.addEventListener('click', closeAll);

      if (d.plans) {
        var slides = Array.prototype.slice.call(d.plans.querySelectorAll('[data-npwmp-plan-slide]'));
        var counter = d.plans.querySelector('[data-npwmp-plan-i]');
        var stage = d.plans.querySelector('.plan-gallery__stage');
        var at = 0;
        function showPlan(i) {
          if (!slides.length) return;
          resetZoom(d.plans);
          at = (i + slides.length) % slides.length;
          slides.forEach(function (im, n) { im.classList.toggle('is-active', n === at); });
          if (counter) counter.textContent = at + 1;
        }
        var prev = d.plans.querySelector('[data-npwmp-plan-prev]');
        var next = d.plans.querySelector('[data-npwmp-plan-next]');
        if (prev) prev.addEventListener('click', function () { showPlan(at - 1); });
        if (next) next.addEventListener('click', function () { showPlan(at + 1); });

        // Tap or click the plan to zoom to 2x, centred on the tap point; pan is
        // native scroll. Tapping again zooms back out.
        if (stage) stage.addEventListener('click', function (e) {
          var im = e.target.closest && e.target.closest('.plan-slide');
          if (!im) return;
          if (stage.classList.contains('is-zoomed')) { resetZoom(d.plans); return; }
          var r = im.getBoundingClientRect();
          var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          stage.classList.add('is-zoomed');
          requestAnimationFrame(function () {
            stage.scrollLeft = fx * im.clientWidth - stage.clientWidth / 2;
            stage.scrollTop = fy * im.clientHeight - stage.clientHeight / 2;
          });
        });

        // Narrow screens have no room beside the drawer, so the gallery opens over it.
        var openBtn = d.panel.querySelector('[data-npwmp-plans-open]');
        if (openBtn) openBtn.addEventListener('click', function () { d.plans.classList.add('is-fullscreen'); });
        var closeBtn = d.plans.querySelector('[data-npwmp-plans-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { d.plans.classList.remove('is-fullscreen'); resetZoom(d.plans); });
      }

      // Swipe-right-to-close (mobile)
      var startX = 0, startY = 0, curX = 0, horizontal = false;
      d.panel.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = curX = e.touches[0].clientX; startY = e.touches[0].clientY; horizontal = false;
      }, { passive: true });
      d.panel.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        curX = e.touches[0].clientX;
        var dx = curX - startX, dy = e.touches[0].clientY - startY;
        if (!horizontal) {
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) { horizontal = true; d.panel.classList.add('dragging'); }
          else if (Math.abs(dy) > 10) { return; }
        }
        if (horizontal) d.panel.style.transform = 'translateX(' + Math.max(0, dx) + 'px)';
      }, { passive: true });
      d.panel.addEventListener('touchend', function () {
        if (!horizontal) return;
        d.panel.classList.remove('dragging');
        var dx = curX - startX;
        d.panel.style.transform = '';
        horizontal = false;
        if (dx > 90) closeAll();
      });
    });

    root.querySelectorAll('[data-npwmp-open]').forEach(function (link) {
      link.addEventListener('click', function (e) { e.preventDefault(); openByTarget(link.dataset.npwmpOpen); });
    });
    root.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('.ship-more');
      if (s) { e.preventDefault(); openByTarget('shipping'); }
    });

    // Click the dim (the host itself, anywhere outside the panel) or press Esc to close.
    host.addEventListener('click', function (e) { if (e.target === host) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && host.classList.contains('is-open')) closeAll(); });
  })();

  // ---- add to cart ----
  // Shared cart add: posts the items, refreshes and opens the mini cart. `btn` gets
  // the loading state; `primaryId` is reported to the cart-update publish.
  function addItems(items, btn, primaryId) {
    if (btn && btn.classList.contains('loading')) return;
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
    var miniCart = document.querySelector('mini-cart');
    var sections = miniCart && typeof miniCart.getSectionsToRender === 'function'
      ? miniCart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var body = { items: items };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (r && r.status) { console.error('[npwmp] cart add error', r); return; }
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'npwmp-hero', productVariantId: primaryId });
        }
        if (miniCart && typeof miniCart.renderContents === 'function') {
          try { miniCart.renderContents(r); } catch (err) { console.error(err); }
          setTimeout(function () { if (typeof miniCart.open === 'function') miniCart.open(); }, 100);
        } else {
          window.location = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        console.error('[npwmp] cart add failed', err);
      });
  }
  var form = root.querySelector('[data-npwmp-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = root.querySelector('[data-npwmp-variant-input]');
      var cta = root.querySelector('[data-npwmp-cta]');
      if (!input || !input.value) return;
      var items = [{ id: input.value, quantity: 1 }];
      // For each checked accessory, add its pre-order counterpart variant when the
      // Pre-order option is selected (backend shipping profiles), otherwise the
      // visible in-stock variant. The shopper sees the same name/price either way.
      var usePreorder = !IS_SWAPPED && state.fulfillment === 'preorder';
      root.querySelectorAll('[data-npwmp-accessory]:checked').forEach(function (chk) {
        var preId = chk.getAttribute('data-acc-preorder-variant');
        var id = (usePreorder && preId) ? preId : chk.value;
        var qty = (chk.hasAttribute('data-acc-window-qty') || chk.hasAttribute('data-acc-qty-sel')) ? (parseInt(chk.getAttribute('data-acc-qty'), 10) || 1) : 1;
        if (id) items.push({ id: id, quantity: qty });
      });
      addItems(items, cta, input.value);
    });
  }
  // "Buy separately": only the side product (add-on shed from its tooltip, or the
  // row under the CTA) goes to the cart, colour-matched; the page product does not.
  root.querySelectorAll('[data-npwmp-buy-alone]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var v = btn.getAttribute('data-alt-key') === 'alt' ? altVariantFor() : addonVariantFor();
      if (!v || !v.available) return;
      igUpsellEvent('buyAlone_' + (btn.getAttribute('data-alt-key') || 'swap'));
      addItems([{ id: v.id, quantity: 1 }], btn, v.id);
    });
  });

  // ---- "Watch product video" triggers (corner badge + button under the gallery) -> sound-on pop-up ----
  (function () {
    var triggers = root.querySelectorAll('[data-npwmp-vopen]');
    var modal = root.querySelector('[data-npwmp-vmodal]');
    if (!triggers.length || !modal) return;
    var closeBtn = modal.querySelector('[data-npwmp-vmodal-close]');
    // Either native <video> elements or Wistia <wistia-player> elements (same slots, same
    // desktop/mobile CSS switch); both expose play()/pause()/currentTime/muted.
    var videos = Array.prototype.slice.call(modal.querySelectorAll('video, [data-npwmp-wplayer]'));
    var lastFocus = null;

    // With a separate desktop/mobile video, CSS shows exactly one; play the visible
    // one (offsetParent is null for the display:none copy). Falls back to the only video.
    function visibleVideo() {
      for (var i = 0; i < videos.length; i++) { if (videos[i].offsetParent !== null) return videos[i]; }
      return videos[0] || null;
    }
    function isWistia(v) { return v && v.tagName && v.tagName.toLowerCase() === 'wistia-player'; }
    function playEl(v, at) {
      if (!v) return;
      var go = function () {
        try { if (!isWistia(v)) v.currentTime = 0; } catch (e) {}
        // hand-off from the gallery slide: continue at the same second. Wistia stays paused when it is asked to seek before the
        // first play, so: start, wait until it really runs, seek once, and nudge play again if the seek paused it.
        if (at > 0) {
          var tries = 0, sought = false, iv = setInterval(function () {
            tries++;
            try {
              var st = isWistia(v) ? v.state : (v.paused ? 'paused' : 'playing');
              if (!sought && (st === 'playing' || tries > 12)) { sought = true; v.currentTime = at; }
              else if (sought && st !== 'playing' && !modal.hidden) { var pp = v.play && v.play(); if (pp && pp.catch) pp.catch(function () {}); }
            } catch (e) {}
            if (tries > 24 || modal.hidden) clearInterval(iv);
          }, 150);
        }
        try { v.muted = false; } catch (e) {}       // click is a user gesture, so audio is allowed
        try { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
        // Wistia can re-mute on play when the media's own autoplay setting is "silent": unmute again once it runs
        if (isWistia(v)) { [250, 900].forEach(function (ms) { setTimeout(function () { try { if (v.muted) v.muted = false; } catch (e) {} }, ms); }); }
      };
      // A wistia-player that has not upgraded yet has no play(); wait for definition once.
      if (isWistia(v) && typeof v.play !== 'function' && window.customElements && customElements.whenDefined) {
        customElements.whenDefined('wistia-player').then(go).catch(function () {});
      } else { go(); }
    }

    function open(at) {
      at = typeof at === 'number' ? at : 0;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      root.dispatchEvent(new CustomEvent('npwmp:vmodal-open'));
      playEl(visibleVideo(), at);
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      if (modal.hidden) return;
      var cv = visibleVideo(), ct = 0;
      try { ct = cv ? (cv.currentTime || 0) : 0; } catch (e) {}
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      videos.forEach(function (v) { try { if (v.pause) v.pause(); } catch (e) {} });
      root.dispatchEvent(new CustomEvent('npwmp:vmodal-close', { detail: { time: ct } }));
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }

    function tourOpen(src) { try { if (window.yghTrack) window.yghTrack('tour_open', src); } catch (e) {} }
    triggers.forEach(function (t) { t.addEventListener('click', function () { t.classList.add('is-seen'); tourOpen(t.classList.contains('hero-vbtn') ? 'row' : t.closest('.hero-left') ? 'circle' : 'section'); open(0); }); });
    root.addEventListener('npwmp:vsl-expand', function (e) { tourOpen('expand'); open(e.detail && e.detail.time); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  })();

  // ---- offer card (VSL page v3): the FAQ dropdown under the gallery; on phones the two boxes move under the drawers ----
  (function () {
    var under = root.querySelector('.npo-under'), left = root.querySelector('.hero-left'), right = root.querySelector('.hero-right');
    if (under && left && right && window.matchMedia) {
      var mq = window.matchMedia('(max-width: 749px)');
      var place = function () { if (mq.matches) { if (under.parentNode !== right) right.appendChild(under); } else if (under.parentNode !== left) { var vb = left.querySelector('.hero-vbtn'); left.insertBefore(under, vb || null); } };
      place();
      if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
    }
    var t = root.querySelector('[data-npo-faq-toggle]'), p = root.querySelector('[data-npo-faq]');
    if (!t || !p) return;
    t.addEventListener('click', function () {
      var open = p.hidden;
      p.hidden = !open;
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { try { if (window.yghTrack) window.yghTrack('drawer_open', 'offer_faq'); } catch (e) {} }
    });
  })();

  render();
}

  function boot(scope) {
    var blobs = (scope || document).querySelectorAll('[data-npwmp-data]');
    for (var i = 0; i < blobs.length; i++) init(blobs[i].getAttribute('data-npwmp-data'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* moved from the hero section 2026-09-28 (inline block 1); runs once per page */
(function(){ if (window.__nordHeroInline1) return; window.__nordHeroInline1 = true;
                /* Promo code chip: click to copy with a short confirmation state. Delegated +
                   guarded so multiple hero instances share one listener. */
                (function () {
                  if (window.__nphPromoCopy) return; window.__nphPromoCopy = true;
                  document.addEventListener('click', function (e) {
                    var btn = e.target.closest('[data-promo-code]');
                    if (!btn) return;
                    var label = btn.querySelector('.promo-code-text');
                    var code = btn.getAttribute('data-code');
                    function done() {
                      label.textContent = 'Copied';
                      btn.classList.add('is-copied');
                      clearTimeout(btn.__nphT);
                      btn.__nphT = setTimeout(function () { label.textContent = code; btn.classList.remove('is-copied'); }, 1800);
                    }
                    function fallback() {
                      var ta = document.createElement('textarea');
                      ta.value = code; ta.setAttribute('readonly', '');
                      ta.style.position = 'fixed'; ta.style.opacity = '0';
                      document.body.appendChild(ta); ta.select();
                      var ok = false;
                      try { ok = document.execCommand('copy'); } catch (err) {}
                      document.body.removeChild(ta);
                      return ok;
                    }
                    if (navigator.clipboard && window.isSecureContext) {
                      navigator.clipboard.writeText(code).then(done, function () { if (fallback()) done(); });
                    } else if (fallback()) { done(); }
                  });
                })();

})();

/* moved from the hero section 2026-09-28 (inline block 2); runs once per page */
(function(){ if (window.__nordHeroInline2) return; window.__nordHeroInline2 = true;
            (function(){
              function init(el){
                var tpl    = el.getAttribute('data-stock-template') || 'LIMITED STOCK - [n] UNITS LEFT';
                var start  = parseInt(el.getAttribute('data-stock-start'),10);  if(isNaN(start)) start = 44;
                var floor  = parseInt(el.getAttribute('data-stock-floor'),10);  if(isNaN(floor)) floor = 7;
                var dropTo = parseInt(el.getAttribute('data-stock-drop-to'),10);
                var dropAt = (el.getAttribute('data-stock-drop-at') || '').replace('T',' ').slice(0,16);
                var key    = 'npwmp_stock_' + (el.getAttribute('data-stock-key') || 'p');

                var store; try { store = window.localStorage; } catch(e){ store = null; }
                var st = { visits: 0, dwell: 0 };
                if(store){ try { var raw = store.getItem(key); if(raw){ var p = JSON.parse(raw); st.visits = p.visits||0; st.dwell = p.dwell||0; st.seed = p.seed||0; } } catch(e){} }
                st.visits += 1;                       // this load is a visit
                if(!st.seed){ st.seed = (Math.floor(Math.random() * 4294967295) >>> 0) || 1; }  // stable jitter seed per visitor
                var baseDwell = st.dwell;             // seconds banked from previous visits
                function save(){ if(store){ try { store.setItem(key, JSON.stringify(st)); } catch(e){} } }
                save();

                function nowET(){ try { return new Date().toLocaleString('sv-SE', { timeZone: 'America/New_York' }); } catch(e){ return ''; } }
                function dropped(){ if(!dropAt || isNaN(dropTo)) return false; var n = nowET(); return n ? (n.slice(0,16) >= dropAt) : false; }

                function mulberry32(a){ return function(){ a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
                function dwellDrops(){
                  // first drop ~40s; each later drop takes progressively longer, with slight (seed-stable) jitter
                  var rng = mulberry32(st.seed >>> 0), t = 0, drops = 0, gap = 40;
                  for(var i = 0; i < 300; i++){
                    t += gap * (0.8 + rng() * 0.4);   // jitter +/-20%
                    if(t <= st.dwell){ drops++; gap *= 1.4; } else break;  // widen the next interval
                  }
                  return drops;
                }
                function personalDrop(){
                  var fromVisits = Math.floor((st.visits - 1) / 2);  // ~every 2 refreshes: -1
                  return fromVisits + dwellDrops();
                }
                function value(){
                  var base = dropped() ? dropTo : start;
                  var n = base - personalDrop();
                  return n < floor ? floor : n;
                }
                var textEl = el.querySelector('[data-npwmp-stock-text]') || el;
                function escHtml(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
                function render(){ var n = value(); textEl.innerHTML = escHtml(tpl.replace('[n]', n)).replace(/\*\*([\s\S]+?)\*\*/g, '<span class="cta-hl">$1</span>'); var mirrors = document.querySelectorAll('[data-ship-stock-n]'); for(var k = 0; k < mirrors.length; k++){ mirrors[k].textContent = n; } }
                render();

                var t0 = Date.now();
                setInterval(function(){
                  st.dwell = baseDwell + Math.floor((Date.now() - t0) / 1000);
                  save();
                  render();
                }, 12000);
              }
              var nodes = document.querySelectorAll('[data-npwmp-stock]');
              for(var i = 0; i < nodes.length; i++) init(nodes[i]);
            })();

})();

/* moved from the hero section 2026-09-28 (inline block 3); runs once per page */
(function(){ if (window.__nordHeroInline3) return; window.__nordHeroInline3 = true;
      (function () {
        if (window.__callbackButtonInit) return;
        window.__callbackButtonInit = true;
        if (!window.__hsFormsLoaded_246042012) {
          window.__hsFormsLoaded_246042012 = true;
          var s = document.createElement('script');
          s.src = 'https://js-na2.hsforms.net/forms/embed/246042012.js';
          s.defer = true;
          document.head.appendChild(s);
        }
        function moveModalsToBody() {
          document.querySelectorAll('[data-callback-modal]').forEach(function (m) {
            if (m.parentElement !== document.body) document.body.appendChild(m);
          });
        }
        if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', moveModalsToBody); } else { moveModalsToBody(); }
        function injectIframe(modal) {
          var embed = modal.querySelector('[data-callback-embed]');
          if (!embed || embed.querySelector('.hs-form-frame, [data-ygh-native-form]')) return;
          var d = document.createElement('div');
          d.className = 'hs-form-frame';
          d.setAttribute('data-region', modal.getAttribute('data-callback-hs-region') || 'na2');
          d.setAttribute('data-form-id', modal.getAttribute('data-callback-hs-form'));
          d.setAttribute('data-portal-id', modal.getAttribute('data-callback-hs-portal') || '246042012');
          embed.appendChild(d);
        }
        function preloadAll() {
          document.querySelectorAll('[data-callback-modal]').forEach(injectIframe);
        }
        // Pre-load the survey in the background at idle — lower priority than PDP images.
        if ('requestIdleCallback' in window) {
          requestIdleCallback(function () { preloadAll(); }, { timeout: 4000 });
        } else {
          setTimeout(preloadAll, 2500);
        }
        document.addEventListener('click', function (e) {
          var openBtn = e.target.closest('[data-callback-open]');
          if (openBtn) {
            var modal = document.getElementById(openBtn.getAttribute('aria-controls'));
            if (modal) openModal(modal);
            return;
          }
          var closeBtn = e.target.closest('[data-callback-close]');
          if (closeBtn) { var modal = closeBtn.closest('[data-callback-modal]'); if (modal) closeModal(modal); }
        });
        document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; var open = document.querySelector('[data-callback-modal]:not([hidden])'); if (open) closeModal(open); });
        function openModal(modal) {
          injectIframe(modal); // ensure it exists if opened before idle preload ran
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
        }
        function closeModal(modal) {
          modal.hidden = true;
          document.body.style.overflow = '';
        }
      })();


})();
